// TODO: refactor jQuery --> ES
/**
 * Replace SVGs loaded as image with inline SVGs
 */
export default class IconLoader {
	constructor(app) {
		this.app = app;

		this.loadSvgs();

		// #FIXME: looks like it doesn't work
		$(document).on('load', '.js-section-container', this.loadSvgs);
		$(document).on('load', '.js-post-section', this.loadSvgs);
	}

	loadSvgs() {
		$('img.js-svg').each(function () {
			let $replacer = $(this);
			$.get($replacer.attr('src'), function (data) {
				let $content = $(data).find('svg');
				for (let i = 0; i < $replacer[0].classList.length; i++) {
					$content[0].classList.add($replacer[0].classList[i]);
				}
				$replacer.replaceWith($content);
			});
		});
	}
}
